import * as React from 'react'

function SvgRo(props) {
	return (
		<svg viewBox="0 0 3 2" width="1em" height="1em" {...props}>
			<path fill="#002B7F" d="M0 0h1v2H0z" />
			<path fill="#FCD116" d="M1 0h1v2H1z" />
			<path fill="#CE1126" d="M2 0h1v2H2z" />
		</svg>
	)
}

export default SvgRo
